import { render, staticRenderFns } from "./FileElement.vue?vue&type=template&id=be7c2c3a&"
import script from "./FileElement.vue?vue&type=script&lang=js&"
export * from "./FileElement.vue?vue&type=script&lang=js&"
import style0 from "./FileElement.vue?vue&type=style&index=0&id=be7c2c3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports